const timesheetSystemBulkServiceName = "/TimesheetBulk";

export function timesheetSystemBulkService(http) {
    return {      
        bulkSaveTimesheetAsync: async (personnelCode, activityCode, activityDiscipline, costCenterCode, date,jalaliDate,
            basic, overtime, mission, homework, curtrentUser, userName, duplicateType, duplicateNumber, isBulkSaving)  => {    
            let timesheetParam = {
                PersonnelCode: personnelCode,
                ActivityCode: activityCode,
                ActivityDiscipline: activityDiscipline,
                CostCenterCode: costCenterCode,                
                Date: date,
                Basic: basic,
                Overtime: overtime,
                Mission: mission,
                Homework: homework,
                CurrentUser: curtrentUser,
                UserName: userName,
                DuplicateType: duplicateType,
                DuplicateNumber: duplicateNumber,
                IsBulkSaving: isBulkSaving,
                JalaliToday: jalaliDate
            }   
            return await http.post(timesheetSystemBulkServiceName + "/BulkSaveTimesheetAsync", timesheetParam);
        },
    }
    
}